import React from 'react';

export function useDoubleClick(onSingleClick: (e: React.MouseEvent) => void, onDoubleClick: (e: React.MouseEvent) => void, latency: number = 300) {
	let timeout: ReturnType<typeof setTimeout> | undefined;

	return function clickHandler(e: React.MouseEvent) {
		e.persist();
		e = {...e};
		if (timeout) {
			clearTimeout(timeout);
			timeout = undefined;
			onDoubleClick(e);
		} else {
			timeout = setTimeout(() => {
				timeout = undefined;
				onSingleClick(e);
			}, latency);
		}
	};
}
